var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.inputClass,attrs:{"role":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.clicked($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }